// types
import {
  DefaultConfigProps,
  MenuOrientation,
  ThemeDirection,
} from 'types/config';

// ==============================|| THEME CONSTANT ||============================== //

export const twitterColor = '#1DA1F2';
export const facebookColor = '#3b5998';
export const linkedInColor = '#0e76a8';

export const APP_DEFAULT_PATH = '/dashboard';
export const HORIZONTAL_MAX_ITEM = 6;
export const DRAWER_WIDTH = 280;
export const MINI_DRAWER_WIDTH = 90;
export const HEADER_HEIGHT = 74;

// ==============================|| THEME CONFIG ||============================== //

export enum ThemeMode {
  LIGHT = 'light',
  DARK = 'dark',
  AUTO = 'auto',
}

const config: DefaultConfigProps = {
  fontFamily: `Inter var`,
  i18n: 'en',
  menuOrientation: MenuOrientation.VERTICAL,
  menuCaption: true,
  miniDrawer: false,
  container: false,
  mode: ThemeMode.LIGHT,
  presetColor: 'theme5',
  themeDirection: ThemeDirection.LTR,
  themeContrast: false,
};

// ==============================|| API CONSTANT ||============================== //

//Local Pc Run
//export const API_URL = "http://localhost:5000/api/";
//export const FILE_PATH = "http://localhost:5000/image-path";

export const RAZORPAY_ID = 'rzp_test_a0v08QcQtNwbzl';

//export const API_URL = 'http://154.26.133.118:5000/api/';
//export const FILE_PATH = 'http://154.26.133.118:5000/image-path';

//New Server Insider Run
 export const API_URL = "https://insider.guiview.com/api/api/";
 export const FILE_PATH = "https://insider.guiview.com/api/image-path";

export const AMOUNT_API_URL = 'https://open.er-api.com/v6/latest/USD';

export default config;
